<script setup>
import { sortAgeGroup, swalError } from '@/helper';
import { get_assessment, update_assessment } from '@/services/assessments';
import { get_terms } from '@/services/terms';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute()
const isLoading = ref(true)
const assessment = ref({
  name: '',
  code: '',
  indicators_attributes: [{name: ''}],
  trait_id: ''
})
const trait_config = ref({
  name: ''
})
const ageGroupOption = ref([])
const assessment_term = ref()
onMounted(async ()=>{
  assessment.value.trait_id = route.params.trait_id
  let response = await get_assessment(route.params.id)
  if (response.error){
    if (!response.isRedirecting) swalError(response.message || 'Failed to load assessment')
    return
  }

  assessment.value['id'] = response.result.data.data.id
  assessment.value.name = response.result.data.data.attributes.name
  assessment.value.code = response.result.data.data.attributes.code
  assessment.value.package_id = response.result.data.data.relationships?.package?.data?.id || null
  assessment.value.trait_id = response.result.data.data.relationships?.trait?.data?.id || route.params.trait_id
  assessment.value.indicators_attributes = response.result.data.included.map(item =>{
    if (item.type == 'indicator'){
      return {
        name: item.attributes.name,
        id: item.id,
        _destroy: false
      }
    }
  })
  assessment.value.indicators_attributes = assessment.value.indicators_attributes.filter(item => item )
  // console.log("🚀 ~ file: editAssessment.vue:32 ~ onMounted ~ assessment.value:", assessment.value)

  trait_config.value.name = response.result.data.included.find(item => item.type == 'trait').attributes.name
  // console.log("🚀 ~ file: editAssessment.vue:34 ~ onMounted ~ trait_config.value:", trait_config.value)
  assessment_term.value = response.result.data.meta.term_relationship
  let age_group_response = await get_terms('age_group')
  if (age_group_response.error){
    if (!age_group_response.isRedirecting) swalError(age_group_response.message || 'Failed to load age groups')
    return
  }
  // console.log("🚀 ~ file: assessmentNew.vue:27 ~ onMounted ~ age_group_response:", age_group_response)
  ageGroupOption.value = generateOption(age_group_response.result.data.data)

  isLoading.value = false
})

function generateOption(reponse){
  reponse = reponse.map(item => {
    return {
      valueProp: item.relationships.term_taxonomy.data.id,
      label: item.attributes.name,
      disabled: false
    }
  })
  return sortAgeGroup(reponse)
  // console.log("🚀 ~ file: characterCard.vue:39 ~ generateOption ~ traitOptions.value:", traitOptions.value)
}

const temp_indicator = ref('')
function addIndicator(){
  assessment.value.indicators_attributes.push({
    name: temp_indicator.value,
    id: '',
    _destroy: false
  })
  temp_indicator.value = ''
}

function removeIndicator(index, indicatorObj, indicators){
  if (indicatorObj.id == ''){
    assessment.value.indicators_attributes.splice(index, 1)
  }else{
    // console.log("🚀 ~ file: editAssessment.vue:57 ~ removeIndicator ~ indicatorObj:", indicatorObj)
    assessment.value.indicators_attributes[index]._destroy = true
    // console.log("🚀 ~ file: editAssessment.vue:60 ~ removeIndicator ~ indicator:", indicator)
    // indicator._destroy = true
    indicators = indicators.map(item =>{
      if (item === indicatorObj){
        item._destroy = 'true'
      }
      return item
    })
  }
}

const isSubmitting = ref(false)
async function updateAssessment(){
  isSubmitting.value = true
  const assessmentParams = {
    assessment_obj:{
      ...assessment.value
    },
    term_relationship:{
      id: assessment_term.value.id,
      term_taxonomy_id: assessment_term.value.term_taxonomy_id
    }
  }
  // console.log("🚀 ~ updateAssessment ~ assessmentParams:", assessmentParams)
  let response = await update_assessment(assessment.value.id, assessmentParams)
  // console.log("🚀 ~ file: assessmentNew.vue:37 ~ createAssessment ~ response:", response)
  if (response.error){
    if (!response.isRedirecting) {
      Swal.fire({
        title: 'Error',
        html: response.message || 'Failed to update assessment',
        icon: 'error'
      })
    }
  }else{
    Swal.fire({
      title: 'Updated',
      text: "Assessment has been updated",
      icon: 'success'
    })
  }
  isSubmitting.value = false
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs 
      main="Assessment and Indicators" 
      :title="trait_config.name + ' - Edit Assessment'"
      :mainRoute="{name: 'package-assessment-list'}"
      :titleRoute="{name: 'assessment-list', params: {package_id: assessment.package_id || 'unknown', trait_id: assessment.trait_id}}"
    />

    <LoadingCard v-if="isLoading" />
    <template v-else>
      <!-- Page title -->
      <div class="d-flex align-items-center">
        <div>
          <h4 class="mb-0">Edit assessment for {{ trait_config.name }}</h4>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-9 card">
          <div class="card-body">
            <div class="form-items mt-3">
              <div class="row">
                <div class="col-3">
                  <label class="form-label" for="code">Code</label>
                  <input v-model="assessment.code" class="form-control" id="code" type="text" placeholder="Code" required>
                </div>
                <div class="col-12">
                  <label class="form-label" for="assessment_description">Assessment Description</label>
                  <textarea rows="4" v-model="assessment.name"
                    id="assessment_description" placeholder="Assessment Description" 
                    class="form-control"
                    required
                  ></textarea>
                </div>
              </div>
  
              <div v-auto-animate class="mt-4">
                <div>
                  <h6 class="mb-0">Indicators</h6>
                  <p class="text-secondary">Add indicators for assessment</p>
                </div>
                <form @submit.prevent="addIndicator()" class="row mt-3">
                  <div class="col-6">
                    <input class="form-control" 
                      type="text" 
                      placeholder="Indicator Description" required
                      v-model="temp_indicator"
                    >
                  </div>
                  <div class="col-2">
                    <button type="submit" class="btn-rounded-icon p-0 btn btn-success"
                    >
                      <vue-feather type="plus"></vue-feather>
                    </button>
                  </div>
                </form>
                <!-- items -->
                <template v-for="(indicatorObj, index) in assessment.indicators_attributes" :key="indicatorObj?.id">
                  <div v-if="!indicatorObj?._destroy" class="row mt-2">
                    <!-- <p>{{indicator}}</p> -->
                    <div class="col-6">
                      <input class="form-control" 
                        type="text" 
                        placeholder="Indicator Description" required
                        v-model="indicatorObj.name"  
                      >
                    </div>
                    <div class="col-2">
                      <button class="btn-rounded-icon p-0 btn btn-danger"
                        @click="removeIndicator(index, indicatorObj, assessment.indicators_attributes)"
                      >
                        <vue-feather type="x"></vue-feather>
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="card">
            <div class="card-body">
              <div class="row mb-3">
                <label class="form-label" for="age_group_from">Age Group</label>
                <multiselect 
                  v-model="assessment_term.term_taxonomy_id" 
                  placeholder="Select age group"
                  :options="ageGroupOption"
                  valueProp="valueProp"
                  searchable="true"
                ></multiselect>
              </div>
              <button class="btn btn-light-success"
                @click="updateAssessment()"
                :disabled="isSubmitting"
              >
                <div v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <template v-else>
                  Update Assessment
                </template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>